import type { StackProps } from '@chakra-ui/react';
import { Box, HStack, VStack } from '@chakra-ui/react';
import PreciseNum from '@ui/components/Num/PreciseNum';
import { UsdValue } from '@ui/components/Num/UsdValue';
import IfConnected from '@ui/components/Wallet/IfConnected';
import { useNormalTokenConfig } from '@ui/config/token';
import type { NormalToken } from '@ui/config/token/types';
import { DEFAULT_DECIMAL_PLACES } from '@ui/config/ui';
import { useTokenBalance } from '@ui/hooks/contracts/useTokenBalance';
import { useTokenPrice } from '@ui/hooks/tokenPrice';

import { useTokenSelectDialog } from '../useTokenSelectDialog';

type TokenListRowProps = StackProps & {
  token: NormalToken;
};
export const TokenListRow = ({ token, ...props }: TokenListRowProps) => {
  const tokenInfo = useNormalTokenConfig()[token];
  const tokenBalanceRet = useTokenBalance({
    tokenAddress: tokenInfo.address,
  });
  const tokenPriceRet = useTokenPrice({
    token,
  });

  return (
    <HStack
      gap="8px"
      py="16px"
      px="10px"
      mx="-10px"
      cursor="pointer"
      onClick={() => {
        useTokenSelectDialog.getState().onSelectToken?.(token);
        useTokenSelectDialog.getState().close();
      }}
      _hover={{
        bg: 'blue.50',
      }}
      rounded="8px"
      {...props}
    >
      {tokenInfo.Icon && <tokenInfo.Icon boxSize="32px" />}
      <Box flex="1" textStyle="body1Bold">
        {tokenInfo.symbol}
      </Box>
      <IfConnected>
        <VStack alignItems="flex-end">
          <PreciseNum
            decimalPlaces={DEFAULT_DECIMAL_PLACES}
            value={tokenBalanceRet.data}
            textStyle="body1Bold"
          />
          {tokenPriceRet.data !== null && (
            <UsdValue
              value={tokenBalanceRet.data}
              price={tokenPriceRet.data?.usd_price}
              textStyle="caption"
            />
          )}
        </VStack>
      </IfConnected>
    </HStack>
  );
};
